import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Info modal component begins
const InfoModal = (props) => {
  return (
    <Fragment>
      <div className="modal infoModal">
        <div id="showInfo" onClick={props.showModal} className="exitModal">
          <FontAwesomeIcon icon="times" className="icon" />
        </div>
        <div>
        <h2>About GenreBender</h2>
        <p className="modalDescription"> GenreBender is a song recommendation tool built using the Spotify Web API. Input a song of your choice, a genre you'd like to explore and toggle which parameters you're interested in comparing, and the app will provide a recommendation. You can compare the two songs, store song search history and save your favourite recommendations to your Spotify account.</p>
        </div>
        <div>
        <h3>Why do I need to log in?</h3>
          <p className="modalDescription">Good news - you don't! The majority of GenreBender's features are available in guest mode. However, if you're interested in saving the songs you like to your Spotify account, or listening to their full versions in the app, you will need to authorize the app to access your account. This access can be revoked at any time via your Spotify account dashboard.</p>
        </div>
        <div>
        <h3>Scopes</h3>
          <p className="modalDescription">In addition to publicly available scopes, this app will access the user-library-read and user-library-modify scopes of your account. These are the scopes that will allow the app to verify whether a song exists in your library, and save a song to your library.</p>
        </div>
        <div>
        <h3>Credits</h3>
          <p className="modalDescription">Built by <a href="http://www.anamaljkovic.com" target="_blank" rel="noopener noreferrer">Ana Maljkovic</a> using the HackerYou Spotify OAuth Proxy by Ryan Christiani.</p>
        </div>
    </div>
      <div className="modalBackground"></div>
    </Fragment>
  )
}

export default InfoModal;